import { Modal, Text, Button, Stack, Select } from "@mantine/core";
import { useState, useEffect } from "react";
import {
  getMyRoleOptions,
  getExpectedPartnerRoleOptions,
} from "./constants/general.const";

export interface ExpressInterestFormData {
  requesterRole: string;
  expectedPartnerRole: string;
}

interface ExpressInterestModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: (data: ExpressInterestFormData) => void;
  loading?: boolean;
  /** Current user's whoAmI values from their company profile */
  userWhoAmI: string[];
  /** Target company's collaborationIntent values */
  targetCollaborationIntent: string[];
}

export default function ExpressInterestModal({
  opened,
  onClose,
  onConfirm,
  loading = false,
  userWhoAmI,
  targetCollaborationIntent,
}: ExpressInterestModalProps) {
  const [requesterRole, setRequesterRole] = useState<string | null>(null);
  const [expectedPartnerRole, setExpectedPartnerRole] = useState<string | null>(null);

  const myRoleOptions = getMyRoleOptions(userWhoAmI);
  const partnerRoleOptions = getExpectedPartnerRoleOptions(targetCollaborationIntent);

  const isValid = requesterRole && expectedPartnerRole;

  // Reset form when modal closes
  useEffect(() => {
    if (!opened) {
      setRequesterRole(null);
      setExpectedPartnerRole(null);
    }
  }, [opened]);

  const handleConfirm = () => {
    if (!isValid) return;
    onConfirm({
      requesterRole: requesterRole!,
      expectedPartnerRole: expectedPartnerRole!,
    });
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Express Interest"
      centered
      size="md"
      styles={{
        title: {
          fontSize: "20px",
          fontWeight: 600,
        },
      }}
    >
      <Text size="sm" c="dimmed" mb="lg">
        Select the details about your collaboration intent.
      </Text>

      <Stack gap="md">
        <Select
          label="What role am I playing in this collaboration?"
          placeholder="select option"
          data={myRoleOptions}
          value={requesterRole}
          onChange={setRequesterRole}
          withAsterisk
          clearable
          searchable
        />

        <Select
          label="Expected Partner Role"
          placeholder="select option"
          data={partnerRoleOptions}
          value={expectedPartnerRole}
          onChange={setExpectedPartnerRole}
          withAsterisk
          clearable
          searchable
        />

        <Button fullWidth onClick={handleConfirm} loading={loading} disabled={!isValid} mt="sm">
          Confirm & Proceed
        </Button>
      </Stack>
    </Modal>
  );
}
